export const timezoneOptions = [
    // North America
    { value: 'America/New_York', label: 'New York (UTC-05:00)' },
    { value: 'America/New_York|Pittsburgh', label: 'Pittsburgh (UTC-05:00)' },
    { value: 'America/Chicago', label: 'Chicago (UTC-06:00)' },
    { value: 'America/Denver', label: 'Denver (UTC-07:00)' },
    { value: 'America/Denver|Utah', label: 'Utah (UTC-07:00)' },
    { value: 'America/Los_Angeles', label: 'Los Angeles (UTC-08:00)' },
    { value: 'America/Anchorage', label: 'Anchorage (UTC-09:00)' },
    { value: 'America/Toronto', label: 'Toronto (UTC-05:00)' },
    { value: 'America/Vancouver', label: 'Vancouver (UTC-08:00)' },
    { value: 'America/Mexico_City', label: 'Mexico City (UTC-06:00)' },

    // South America
    { value: 'America/Sao_Paulo', label: 'São Paulo (UTC-03:00)' },
    { value: 'America/Buenos_Aires', label: 'Buenos Aires (UTC-03:00)' },
    { value: 'America/Santiago', label: 'Santiago (UTC-04:00)' },
    { value: 'America/Lima', label: 'Lima (UTC-05:00)' },
    { value: 'America/Bogota', label: 'Bogota (UTC-05:00)' },

    // Europe
    { value: 'Europe/London', label: 'London (UTC+00:00)' },
    { value: 'Europe/Paris', label: 'Paris (UTC+01:00)' },
    { value: 'Europe/Berlin', label: 'Berlin (UTC+01:00)' },
    { value: 'Europe/Madrid', label: 'Madrid (UTC+01:00)' },
    { value: 'Europe/Rome', label: 'Rome (UTC+01:00)' },
    { value: 'Europe/Amsterdam', label: 'Amsterdam (UTC+01:00)' },
    { value: 'Europe/Brussels', label: 'Brussels (UTC+01:00)' },
    { value: 'Europe/Vienna', label: 'Vienna (UTC+01:00)' },
    { value: 'Europe/Moscow', label: 'Moscow (UTC+03:00)' },
    { value: 'Europe/Istanbul', label: 'Istanbul (UTC+03:00)' },
    { value: 'Europe/Stockholm', label: 'Stockholm (UTC+01:00)' },
    { value: 'Europe/Oslo', label: 'Oslo (UTC+01:00)' },
    { value: 'Europe/Copenhagen', label: 'Copenhagen (UTC+01:00)' },
    { value: 'Europe/Dublin', label: 'Dublin (UTC+00:00)' },
    { value: 'Europe/Lisbon', label: 'Lisbon (UTC+00:00)' },

    // Asia
    { value: 'Asia/Tokyo', label: 'Tokyo (UTC+09:00)' },
    { value: 'Asia/Shanghai', label: 'Shanghai (UTC+08:00)' },
    { value: 'Asia/Hong_Kong', label: 'Hong Kong (UTC+08:00)' },
    { value: 'Asia/Singapore', label: 'Singapore (UTC+08:00)' },
    { value: 'Asia/Seoul', label: 'Seoul (UTC+09:00)' },
    { value: 'Asia/Dubai', label: 'Dubai (UTC+04:00)' },
    { value: 'Asia/Bangkok', label: 'Bangkok (UTC+07:00)' },
    { value: 'Asia/Kolkata', label: 'Mumbai/Delhi (UTC+05:30)' },
    { value: 'Asia/Tel_Aviv', label: 'Tel Aviv (UTC+02:00)' },
    { value: 'Asia/Jakarta', label: 'Jakarta (UTC+07:00)' },
    { value: 'Asia/Manila', label: 'Manila (UTC+08:00)' },
    { value: 'Asia/Taipei', label: 'Taipei (UTC+08:00)' },

    // Oceania
    { value: 'Pacific/Auckland', label: 'Auckland (UTC+12:00)' },
    { value: 'Australia/Sydney', label: 'Sydney (UTC+10:00)' },
    { value: 'Australia/Melbourne', label: 'Melbourne (UTC+10:00)' },
    { value: 'Australia/Perth', label: 'Perth (UTC+08:00)' },
    { value: 'Australia/Brisbane', label: 'Brisbane (UTC+10:00)' },

    // Africa
    { value: 'Africa/Cairo', label: 'Cairo (UTC+02:00)' },
    { value: 'Africa/Johannesburg', label: 'Johannesburg (UTC+02:00)' },
    { value: 'Africa/Lagos', label: 'Lagos (UTC+01:00)' },
    { value: 'Africa/Nairobi', label: 'Nairobi (UTC+03:00)' },
    { value: 'Africa/Casablanca', label: 'Casablanca (UTC+00:00)' }
];
